import React from 'react';
import { bool, shape, string } from 'prop-types';

const ApplicationColor = ({
  className = 'icon',
  notUseClass = false,
  color = '#696f88',
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.27124 12C5.45781 13.6874 6.88782 15 8.625 15C10.3622 15 11.7922 13.6874 11.9788 12H15.75V13.5H13.1235C12.3892 15.2615 10.6528 16.5 8.625 16.5C6.59724 16.5 4.86076 15.2615 4.12646 13.5H1.5V12H5.27124Z" fill="currentColor" />
    <path d="M7.34985 12.5251C7.42486 12.1502 7.8 11.925 8.25 12L9 12.2249C9.37482 12.3 9.60005 12.7501 9.52515 13.125C9.45017 13.4999 8.99994 13.725 8.625 13.6501L7.875 13.4253C7.50002 13.3503 7.2749 12.9001 7.34985 12.5251Z" fill="currentColor" />
    <path d="M9.44971 9.90015C9.6747 9.52523 10.125 9.37496 10.5 9.59985C10.8748 9.82487 10.9502 10.2752 10.8003 10.6501L10.4253 11.3254C10.2003 11.7003 9.74992 11.7749 9.375 11.625C9.00016 11.4001 8.92492 10.9503 9.07471 10.5754L9.44971 9.90015Z" fill="currentColor" />
    <path d="M6.30029 8.84985C6.60023 8.55019 7.04995 8.55013 7.34985 8.84985L7.875 9.375C8.17484 9.67497 8.17487 10.1253 7.875 10.4253C7.57515 10.725 7.12538 10.7248 6.82544 10.4253L6.30029 9.90015C6.00029 9.60015 6.00029 9.14985 6.30029 8.84985Z" fill="currentColor" />
    <path d="M10.689 3.49365L12.3765 2.52026L14.2515 5.76782L11.1636 7.3894C10.8376 7.5606 10.4595 7.60603 10.1023 7.51685L6.94336 6.72803C6.5417 6.6275 6.29739 6.22007 6.39771 5.81836C6.49817 5.41661 6.90561 5.17165 7.30737 5.27197L8.72827 5.60669C9.0081 5.67674 9.36445 5.65158 9.42773 5.33789C9.49102 5.0242 9.27942 4.85826 8.99487 4.78198L6.77856 4.20264L2.58911 6.25633C2.21975 6.44319 1.73141 6.25183 1.56655 5.85096C1.40906 5.46799 1.54231 4.96913 1.91162 4.78198L6.35815 2.53125L6.6145 2.40234L10.689 3.49365Z" fill="currentColor" />
    <path d="M16.5667 5.29688L15.2681 6.04688L12.6431 1.5L13.9417 0.75L16.5667 5.29688Z" fill="currentColor" />
  </svg>
);

ApplicationColor.propTypes = {
  className: string,
  notUseClass: bool,
  color: string,
  style: shape({}),
};

export default ApplicationColor;
